import React, {useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {myroutes} from "../../routes/webroute";
import {Button, Container, Form, Nav, Navbar, NavDropdown, Offcanvas} from "react-bootstrap";
import Media from "react-media";
import {useDispatch, useSelector} from "react-redux";
import { auth, checkAuthenticate, resetAuthData } from "../app/providers/authSlice";
import Login from "../auth/login";
import loginService from "../auth/loginService";
import PersonnesService from "../personnes/PersonnesService";
import EtablissementsService from "../etablissements/EtablissementsService";

export default function TopBar() {

// get current user data 
const currentUser = useSelector(state => state.auth)
const [personnes, setPersonnes] = useState([]);
const [etablissements, setEtablissements] = useState([]);
// use dispatch to execute some reducer function
const dispatch = useDispatch()
const navigate = useNavigate()
const user = useSelector((state) => state.auth.user);
const token = useSelector((state) => state.auth.token);
const [nomUser, setNomUser] = useState("");
const [raisonsocialeEtablissement, setRaisonsocialeEtablissement] = useState("");
const [prenomUser, setPrenomUser] = useState("");

// check if user si authenticate
dispatch(checkAuthenticate())

// check if token exist and not expired
if (!currentUser.isAuthenticate) {
    //deconnecter l'utilisateur et renvoie sur login page 
    dispatch(resetAuthData())
    navigate(myroutes.login)
}

 //get liste personnes
 const fetchPersonnes = async () => {
    await PersonnesService.index(token)
      .then((res) => {
        //  console.log(res.data.data.personnes)
        setPersonnes(res.data.data.personnes);
      })
      .catch((error) => {
        console.log(error);
      });
  };

   //get liste personnes
 const fetchEtablissements = async () => {
    await EtablissementsService.index(token)
      .then((res) => {
            //   console.log(res.data.data.etablissements) 
        setEtablissements(res.data.data.etablissements);
      })
      .catch((error) => {
        console.log(error);
      });
  };


  useEffect(() => {
    if (user) {
      const userInfos = personnes.find(personne => personne.user_id === user.user_id);
      if (userInfos) {
        setNomUser(userInfos.nomPersonne);
        setPrenomUser(userInfos.prenomsPersonne);
      }
    }
  }, [user, personnes]);  
 
    useEffect(() => {
        fetchPersonnes();
        fetchEtablissements();
       // console.log(username) 
    }, [navigate]);

 
    const  onLogoutHandler = () => {
        let check_logout = logoutBackend();
        if (check_logout) { 
            dispatch(resetAuthData()) 
            // redirect login 
        }else{
    
        }
    
        };
          
     
      const logoutBackend = async () => {  
          await loginService.logout(currentUser.token).then(({data})=>{
          //console.log(data.status)
            if (data === "Logged out successfully") {  
              return true; 
            }else{ 
                return false
            }
      
            // navigate("/statuts")
          }).catch(({response})=>{
            return false
          }) 
        }

    return (
        <React.Fragment>
            {/* Navbar */}

            {/*mobile topbar */}
            <Media query="(max-width: 599px)" render={() =>
                (
                    <Navbar key={"sm"} expand={"sm"}
                            className="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme">
                        <Container fluid>
                            <Navbar.Brand href="#">Schoolarys</Navbar.Brand>
                            <Navbar.Toggle aria-controls="offcanvasNavbar-expand-sm"/>
                            <Navbar.Offcanvas
                                id="offcanvasNavbar-expand-sm"
                                aria-labelledby="offcanvasNavbarLabel-expand-sm"
                                placement="end"
                            >
                                <Offcanvas.Header closeButton>
                                    <Offcanvas.Title id="offcanvasNavbarLabel-expand-sm">
                                        Schoolarys
                                    </Offcanvas.Title>
                                </Offcanvas.Header>
                                <Offcanvas.Body>
                                    <Nav className="justify-content-end flex-grow-1 pe-3">
                                        <Nav.Link href="#action1">Dashboards</Nav.Link>
                                        <Nav.Link href="#action2">Link</Nav.Link>
                                        <NavDropdown
                                            title="Dropdown"
                                            id="offcanvasNavbarDropdown-expand-sm"
                                        >
                                            <NavDropdown.Item href="#action3">Action</NavDropdown.Item>
                                            <NavDropdown.Item href="#action4">
                                                Another action
                                            </NavDropdown.Item>
                                            <NavDropdown.Divider/>
                                            <NavDropdown.Item href="#action5">
                                                Something else here
                                            </NavDropdown.Item>
                                        </NavDropdown>
                                    </Nav>
                                    <Form className="d-flex">
                                        <Form.Control
                                            type="search"
                                            placeholder="Search"
                                            className="me-2"
                                            aria-label="Search"
                                        />
                                        <Button variant="outline-success">Search</Button>
                                    </Form>
                                </Offcanvas.Body>
                            </Navbar.Offcanvas>
                        </Container>
                    </Navbar>
                )}
            />


            {/* End mobile topbar */}
            <Media query="(min-width: 599px)" render={() =>
                (
                    <Navbar
                        className="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme"
                        id="layout-navbar"
                    >
                        <div className="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none">
                        <span className="nav-item nav-link px-0 me-xl-4">
                            <i className="bx bx-menu bx-sm"></i>
                        </span>
                        </div>

                        <div className="navbar-nav-right d-flex align-items-center" id="navbar-collapse">
                            {/* Search */}
                            <div className="navbar-nav align-items-center">
                              {/**   <div className="nav-item d-flex align-items-center">
                                    <i className="bx bx-search fs-4 lh-0"></i>
                                    <input
                                        type="text"
                                        className="form-control border-0 shadow-none"
                                        placeholder="Search..."
                                        aria-label="Search..."
                                    />
                                </div>*/}
                            <img className="me-2" src="/images/logo_gs_sans_fond.png" alt="" style={{width:"50px", textAlign:"center"}}/>

                            <p className="fw-bold" style={{textAlign:"center",marginTop:"15px", color:"black", fontSize:"14px"}}>Système de gestion des écoles primaires et secondaires <span> {etablissements.length > 0 && etablissements[0].raisonsocialeEtablissement}</span></p>
                            </div>
                            {/* /Search */}

                            <ul className="navbar-nav flex-row align-items-center ms-auto">
                                {/* Place this tag where you want the button to render. */}


                                {/* User */}
                             
                                <li className="nav-item navbar-dropdown dropdown-user dropdown">
                                
                                    <span className="nav-link dropdown-toggle hide-arrow"
                                       data-bs-toggle="dropdown">
                                        <div className="avatar avatar-online">
                                            <img src="/images/avatar.png" alt
                                                 className="w-px-40 h-auto rounded-circle"/>
                                                  
                                        </div>
                                       
                                    </span>
                                    <ul className="dropdown-menu dropdown-menu-end">
                                      {/**   <li>
                                            <a className="dropdown-item" href="#">
                                               <div className="d-flex">
                                                    <div className="flex-shrink-0 me-3">
                                                        <div className="avatar avatar-online">
                                                            <img src="/images/avatar.png" alt
                                                                 className="w-px-40 h-auto rounded-circle"/>
                                                        </div>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <span className="fw-semibold d-block">{username}</span>
                                                        <small className="text-muted"></small>
                                                    </div>
                                                </div> 
                                            </a>
                                        </li>*/}
                                        <li>
                                            <Link className="dropdown-item">
                                                <i className="bx bx-user me-2"title="Mon profil"></i>
                                                <span className="align-middle">{user ? user.nom : 'Utilisateur inconnu'}</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item">
                                                <i className="bx bx-pencil me-2"></i>
                                                <span className="align-middle">Editer profile</span>
                                            </Link>
                                        </li>
                                        {/*<li>
                                            <a className="dropdown-item" href="#">
                                            <span className="d-flex align-items-center align-middle">
                                            <i className="flex-shrink-0 bx bx-credit-card me-2"></i>
                                            <span className="flex-grow-1 align-middle">Billing</span>
                                            <span
                                                className="flex-shrink-0 badge badge-center rounded-pill bg-danger w-px-20 h-px-20">4</span>
                                            </span>
                                            </a>
                                        </li>*/}
                                        <li>
                                            <div className="dropdown-divider"></div>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" onClick={onLogoutHandler}>
                                                <i className="bx bx-power-off me-2"></i>
                                                <span className="align-middle">Se déconnecter</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </li>
                                {/*/ User */}
                                <div className="flex-grow-1">
                                    <span className="fw-semibold d-block fw-bold" style={{color:"black", fontSize:"14px"}}>{nomUser} {prenomUser}</span>
                                    <small className="text-muted">{}</small>                                     
                                 </div>
                            </ul>
                            
                        </div>
                    </Navbar>
                )}
            />


            {/* / Navbar */}
        </React.Fragment>
    )
}